import { SuccessResponse } from 'shared/api/auth/auth.types'

export interface PasswordRecoveryConfirmRequest {
  token: string
  password: string
  password_confirmation: string
}

export type PasswordRecoveryConfirmResponse = SuccessResponse<{
  message: string
}>
